// extracted by mini-css-extract-plugin
export default {"background-image-wrapper":"backgroundProfile_background-image-wrapper__jTOUp"};